export { default as Dashboard } from './Dashboard.vue'
